import { render, staticRenderFns } from "./ButtonCTA.vue?vue&type=template&id=0e99ca83&scoped=true&"
import script from "./ButtonCTA.vue?vue&type=script&lang=js&"
export * from "./ButtonCTA.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCTA.vue?vue&type=style&index=0&id=0e99ca83&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e99ca83",
  null
  
)

component.options.__file = "ButtonCTA.vue"
export default component.exports